import { forwardRef } from "react";
import { Card, CardHeader, CardProps, CardTitle } from "./ui/card";

interface PageCardProps extends CardProps {
  children: React.ReactNode;
}

export const PageCard = forwardRef<HTMLDivElement, PageCardProps>(
  ({ children, ...props }, ref) => {
    return (
      <Card ref={ref} {...props}>
        {children}
      </Card>
    );
  },
);
PageCard.displayName = "PageCard";

interface PageCardHeaderProps {
  children: React.ReactNode;
}

export function PageCardHeader({ children }: PageCardHeaderProps) {
  return (
    <CardHeader className="flex flex-row place-content-between items-center">
      {children}
    </CardHeader>
  );
}

interface PageCardTitleProps {
  children: React.ReactNode;
}

export function PageCardTitle({ children }: PageCardTitleProps) {
  return (
    <CardTitle className="flex flex-row items-center">{children}</CardTitle>
  );
}
